import { render } from "./InviteMemberForm.vue?vue&type=template&id=dd2a550e&scoped=true&ts=true"
import script from "./InviteMemberForm.vue?vue&type=script&lang=ts"
export * from "./InviteMemberForm.vue?vue&type=script&lang=ts"

import "./InviteMemberForm.vue?vue&type=style&index=0&id=dd2a550e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2a550e"]])

export default __exports__